import { render, staticRenderFns } from "./BetDataTable.vue?vue&type=template&id=1578a1af&scoped=true&"
import script from "./BetDataTable.vue?vue&type=script&lang=js&"
export * from "./BetDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BetDataTable.vue?vue&type=style&index=0&id=1578a1af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578a1af",
  null
  
)

export default component.exports